import {
  PracticeBatterSingleSessionReportChartConfigDto,
  PracticeBatterSingleSessionSummaryChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';
import { useEffect, useMemo } from 'react';
import useReportStore from 'hooks/PracticeReport/BatterSingle/reportStore';
import { PracticeBatterSingleSessionSummaryAggregatedChartColumn } from './PracticeBatterSingleSessionSummaryAggregatedChart';

const liveAtBatStats = [
  'walks',
  'strikeouts',
  'swingPercent',
  'contactPercent',
  'chasePercent',
] as PracticeBatterSingleSessionSummaryAggregatedChartColumn[];

const defaultDisabledVisibleStats = ['session'];

const PracticeBatterSingleSessionSummaryAggregatedChartSidebar = (
  props: ChartConfigProps<PracticeBatterSingleSessionSummaryChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>
) => {
  const { setTempLayout, tempLayout } = props;
  const { searchCriteria } = useReportStore();

  const disabledVisibleStats = useMemo(() => {
    return searchCriteria.sessionType?.id !== 'All' && searchCriteria.sessionType?.id !== 'LiveAB'
      ? [...defaultDisabledVisibleStats, ...liveAtBatStats]
      : [...defaultDisabledVisibleStats];
  }, [searchCriteria.sessionType]);

  useEffect(() => {
    let visibleStats = [...tempLayout.practiceBatterSingleSessionSummaryAggregatedChartConfig.visibleStats];

    if (searchCriteria.sessionType?.id !== 'All' && searchCriteria.sessionType?.id !== 'LiveAB') {
      liveAtBatStats.forEach((stat) => {
        const item = visibleStats.find((item) => item.key === stat);
        if (item) {
          item.checked = false;
        }
      });
    }

    setTempLayout({
      ...tempLayout,
      practiceBatterSingleSessionSummaryAggregatedChartConfig: {
        ...tempLayout.practiceBatterSingleSessionSummaryAggregatedChartConfig,
        visibleStats: visibleStats,
      },
    });
  }, [searchCriteria.sessionType]);

  return (
    <TableChartSidebar
      chartId='PracticeBatterSingleSessionSummaryAggregatedChart'
      configKey='practiceBatterSingleSessionSummaryAggregatedChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PracticeBatterSingleSessionSummaryAggregatedChartSidebar;
